module.exports = __webpack_public_path__ + "img/barrel_sleeve1.4ab9589e.png";